import {
  IBrand,
  ICalendarEventSchedule,
  IPatient,
  IPractice,
  IRole,
  IStaffer,
  ITag,
  ITreatmentCategory,
  IUser,
} from '@principle-theorem/principle-core/interfaces';
import { FirestoreCache, FirestoreQueryCache } from '@principle-theorem/shared';

export class OrganisationCache {
  static practices = new FirestoreCache<IPractice>();
  static brands = new FirestoreCache<IBrand>();
  static roles = new FirestoreCache<IRole>();
  static staff = {
    get: new FirestoreCache<IStaffer>(),
    all: new FirestoreQueryCache<IStaffer>(),
  };
  static rosterSchedules = new FirestoreQueryCache<ICalendarEventSchedule>();
  static users = {
    get: new FirestoreCache<IUser>(),
    byOrganisation: new FirestoreQueryCache<IUser>(),
    byBrand: new FirestoreQueryCache<IUser>(),
    byPractice: new FirestoreQueryCache<IUser>(),
  };
  static appointmentTags = new FirestoreQueryCache<ITag>();
  static patients = new FirestoreCache<IPatient>(20);
  static treatmentCategories = {
    get: new FirestoreCache<ITreatmentCategory>(),
    all: new FirestoreQueryCache<ITreatmentCategory>(),
  };

  static setup(_options: {
    cacheEnabled: boolean;
    limitEnabled: boolean;
    ttlMs?: number;
  }): void {
    throw new Error('Method not implemented in browser environment.');
  }

  static setTTL(ttl: number): void {
    this.practices.setTTL(ttl);
    this.brands.setTTL(ttl);
    this.roles.setTTL(ttl);
    this.staff.get.setTTL(ttl);
    this.staff.all.setTTL(ttl);
    this.rosterSchedules.setTTL(ttl);
    this.users.get.setTTL(ttl);
    this.users.byOrganisation.setTTL(ttl);
    this.users.byBrand.setTTL(ttl);
    this.users.byPractice.setTTL(ttl);
    this.appointmentTags.setTTL(ttl);
    this.patients.setTTL(ttl);
    this.treatmentCategories.get.setTTL(ttl);
    this.treatmentCategories.all.setTTL(ttl);
  }

  static setCacheEnabled(cacheEnabled: boolean): void {
    this.practices.setCacheEnabled(cacheEnabled);
    this.brands.setCacheEnabled(cacheEnabled);
    this.roles.setCacheEnabled(cacheEnabled);
    this.staff.get.setCacheEnabled(cacheEnabled);
    this.staff.all.setCacheEnabled(cacheEnabled);
    this.rosterSchedules.setCacheEnabled(cacheEnabled);
    this.users.get.setCacheEnabled(cacheEnabled);
    this.users.byOrganisation.setCacheEnabled(cacheEnabled);
    this.users.byBrand.setCacheEnabled(cacheEnabled);
    this.users.byPractice.setCacheEnabled(cacheEnabled);
    this.appointmentTags.setCacheEnabled(cacheEnabled);
    this.patients.setCacheEnabled(cacheEnabled);
    this.treatmentCategories.get.setCacheEnabled(cacheEnabled);
    this.treatmentCategories.all.setCacheEnabled(cacheEnabled);
  }

  static setLimitEnabled(_limitEnabled: boolean): void {
    throw new Error('Method not implemented in browser environment.');
  }
}
